<template>
  <div class="bg-white rounded box-shadow p-1">
    <b-modal hide-footer id="crop-modal-view" size="lg" title="Crops View" @hidden="onHidden">

      <div class="modal-content bg-white rounded box-shadow" v-if="Object.keys(affected_crop_list).length !== 0">
        <table class="table table-centered table-striped">
          <tr>
            <th>Land Info</th>
            <td>: Land id: {{ affected_crop_list.land.id }}, Mouza: {{ affected_crop_list.land.mouza.mouza_desc }}, Plot: {{ affected_crop_list.land.plot_no }}</td>
          </tr>
          <tr>
            <th>Land Cultivation</th>
            <td>: {{ affected_crop_list.land_cultivation.land_cultivation_desc }}</td>
          </tr>
          <tr>
            <th>Existing crops in the field</th>
            <td>: {{ affected_crop_list.crop_category.crop_category_desc  }}</td>
          </tr>
          <tr>
            <th>Khatian No.</th>
            <td>: {{ affected_crop_list.khatian_num }}</td>
          </tr>
          <tr>
            <th>Cultivated affected land (decimal)</th>
            <td>: {{ affected_crop_list.cultivated_land }}</td>
          </tr>
          <tr>
            <th>Production (Kg)</th>
            <td>: {{ affected_crop_list.production }}</td>
          </tr>
          <tr>
            <th>Present Market Value (Tk.)</th>
            <td>: {{ affected_crop_list.market_value }}</td>
          </tr>
          <tr>
            <th>Remarks</th>
            <td>: {{ affected_crop_list.remarks }}</td>
          </tr>
          <tr>
            <th>CCL No</th>
            <td>
              : {{ affected_crop_list.ccl_crop ? affected_crop_list.ccl_crop.ccl.ccl_no : '' }}
              <span>
                   <router-link :to="{ name: 'cclUpdate', params: { ccl_id: affected_crop_list.ccl_crop.ccl.id } }" tag="a" target="_blank">
                        <span style="font-weight: 100;"> *If Update Need Click here</span>
                   </router-link>
              </span>
<!--              <a href="javascript:void(0);"-->
<!--               title="Update CCL" @click="updateCcl(affected_crop_list.ccl_crop.ccl.id)">-->
<!--                <span style="font-weight: 100;"> *If Update Need Click here</span>-->
<!--              </a>-->
            </td>
          </tr>
          <tr>
            <th>Amount</th>
            <td>: {{ affected_crop_list.ccl_crop ? affected_crop_list.ccl_crop.ccl_amount : ''}}</td>
          </tr>
        </table>
      </div>
    </b-modal>
    <update-ccl-modal
        ref="updateCclModal"
        :ccl_id = "ccl_id"
    >
    </update-ccl-modal>
  </div>
</template>

<script>
import updateCclModal from '../data/ccl/modal/updateCclModal'

export default {
  name: "CropModalView",
  props: ['affected_crop_list'],
  components: {updateCclModal},
  data() {
    return {
      ccl_id: ''
    };
  },

  mounted() {

  },
  methods: {
    updateCcl(ccl_id){
      this.ccl_id = ccl_id
      this.$refs.updateCclModal.onUpdate(ccl_id);
      this.$root.$emit("bv::show::modal", "ccl-update-modal");
    },
    onHidden (e) {
      this.$emit("getPersonAffectedCrop");
    }
  },
};
</script>
